import { AbstractControl, ValidatorFn } from "@angular/forms";

export function invalidCharactersValidator(): ValidatorFn {
  return (control: AbstractControl) : { [key: string]: boolean } | null => {
    if (control.value && !control.value.match(/^[A-Za-z0-9\s\:\)\(\,\-\'\/\*\#]*$/)) {
      return { 'invalidCharacters': true };
    }
    return null;
  };
}



// WEBPACK FOOTER //
// ./src/app/common/validators/invalidCharactersValidator.ts